import { database } from "firebase/app";

import { IFolder } from "../store/modules/library/IFolder";

export const updateFolder = (path: string[], patch: Partial<IFolder>) => {
  const folderPath = `/folders/${path[path.length - 1]}`;
  const parentFolderPath = `/folders/${path.slice(-2).join("/folders/")}`;
  const librariesFolderPath = `/libraries/${path.join("/folders/")}`;

  const updates = Object.entries(patch).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [`${folderPath}/${key}`]: value,
      [`${parentFolderPath}/${key}`]: value,
      [`${librariesFolderPath}/${key}`]: value,
    }),
    {}
  );

  return database().ref().update(updates);
};
